import { render, staticRenderFns } from "./initiateTx.vue?vue&type=template&id=1df8de9a&scoped=true&"
import script from "./initiateTx.vue?vue&type=script&lang=js&"
export * from "./initiateTx.vue?vue&type=script&lang=js&"
import style0 from "./initiateTx.vue?vue&type=style&index=0&id=1df8de9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df8de9a",
  null
  
)

export default component.exports